module.exports = __webpack_public_path__ + "static/p2.69242244.jpg";